import UsageReports from './usage-reports.vue'

const __default__ = {
  props: {
    tenant: {type: Object, required: true}
  },
  data() {
    const data = {
      active: 'usage_reports',
      tabs: [
        {value: 'usage_reports', title: 'Usage Reports'},
        {value: 'stats', title: 'Stats'}
      ]
    }
    return data
  },
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'analytics',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { UsageReports }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})